/*
 * Detect if a given URL is an absolute URL or not
 * Matches for http:// or https:// URLs
 * Does NOT match for other URIs such as mailto: or file://
 */
export const isAbsoluteUrl = (url: string) => {
  return /^https?:\/\//.test(url);
};
